import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får gäster själva fylla på drinkar vid bordet?";
const SHORT_ANSWER = "Servering ska ske från personal med ansvarsfull alkoholhantering. Självservering där gäster fyller på sprit eller starka drinkar är inte tillåten.";

export const Route = createFileRoute("/fraga/far-jag-saljs-pa-bordet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får gäster själva fylla på drinkar vid bordet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Buffésystem för t.ex. öl eller vin kan godkännas om personalen kontrollerar konsumtion och ålder. Sprit ska alltid hanteras av personal. Brott mot detta är vanligaste tillsynsanmärkningen."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-3", label: "Alkohollagen kap. 3 – allmänna bestämmelser" }}
      related={[{"to": "/fraga/vad-betyder-personlig-lamplighet", "label": "Vad betyder personlig lämplighet enligt alkohollagen?"}, {"to": "/fraga/vad-ar-pbi-kretsen", "label": "Vad är PBI-kretsen?"}, {"to": "/fraga/nar-behover-jag-anmala-ny-agare", "label": "När måste jag anmäla ny ägare eller styrelseledamot?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får gäster själva fylla på drinkar vid bordet?" },
      { name: "description", content: "Servering ska ske från personal med ansvarsfull alkoholhantering. Självservering där gäster fyller på sprit eller starka drinkar är inte tillåten." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-saljs-pa-bordet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-saljs-pa-bordet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-saljs-pa-bordet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får gäster själva fylla på drinkar vid bordet", url: "https://alkoholprovet.se/fraga/far-jag-saljs-pa-bordet" },
      ]),
    ],
  }),
});
